import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackHomeViewWithoutPatients = (userId?: string): void => {
  trackingService.trackEvent(
    'BEGIN',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '/inicio',
      placement: '',
      surface: '',
      flow: 'inicio',
      step: 'sem pacientes',
      element: '',
      action: 'view',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackRegisterPatientClick = (userId?: string): void => {
  trackingService.trackEvent(
    'REGISTER',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: 'card',
      flow: 'cadastro paciente',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackProfileMenuExpand = (userId?: string): void => {
  trackingService.trackEvent(
    'PROFILE',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'header',
      surface: 'popover',
      flow: 'logout',
      step: 'inicio',
      element: 'icon button',
      action: 'expand',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackLogoutClick = (userId?: string): void => {
  trackingService.trackEvent(
    'LOGOUT',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'header',
      surface: 'popover',
      flow: 'logout',
      step: 'sair',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackTutorialFooterClick = (userId?: string): void => {
  trackingService.trackEvent(
    'TUTORIALS',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'footer',
      surface: '',
      flow: 'tutoriais',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
